<template>
  <OverlayCard width="m">
    <template #title>
      {{ $t('licensing.unverifiedCard.text.title') }}
    </template>

    <template #content>
      <div v-html="$t('licensing.unverifiedCard.text.main')"></div>
    </template>

    <template #footer>
      <Btn color="blue" @click="$emit('cancel')">{{ $t('action.close') }}</Btn>
    </template>
  </OverlayCard>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  emits: { cancel: null },
  name: 'LicenseUnverifiedCard',
});
</script>
